import type { MenuSchema } from '../MenuSchema.js';

export function createSceneMenuSchema(): MenuSchema {
    return {
        id: 'SCENE',
        title: 'Scene',
        nodes: [
            { type: 'text', text: 'Choose a scene to request for all users' },
        ],
    };
}
